import React from 'react'
import AOS from 'aos';
import SkewImg from './SkewImg';
import Tab from './Tabs';
import LazyLoad from 'react-lazy-load';
import '../CSS/Main.css'
import '../CSS/Common.css'
import '../CSS/Portfolio.css'
import '../CSS/Responsive.css'
import { Link } from 'react-router-dom';

const Portfolio = () => {
  AOS.init(
    {
        disable: false,
        startEvent: 'DOMContentLoaded',
        initClassName: 'aos-init', 
        animatedClassName: 'aos-animate', 
        useClassNames: false,
        disableMutationObserver: false,
        debounceDelay: 50, throttleDelay: 99,
        
        offset: 100, 
        delay: 100,
        duration: 500,
        easing: 'ease-in-out', 
        once: false, 
        mirror: true,
        anchorPlacement: 'top-bottom',
      }
);
    const tabsData = [
      {
        tabTitle: 'Web',
        categories:[
        'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109763/Images/Sumizan%20Images/Web/tuwpe9igmamuii1ekhuo.jpg',
        'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109758/Images/Sumizan%20Images/Web/age2efo6ufq4yskowfek.jpg',
        'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109747/Images/Sumizan%20Images/Web/jin2aiou2p6ufjqhcewc.jpg',
        'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109724/Images/Sumizan%20Images/Web/t6nngiwqfn0gvpg8ltwh.jpg', 
        ],
        width: '35vw',
      },
      {
        tabTitle: 'Mobile',
        categories:[
        'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109621/Images/Sumizan%20Images/Apps/pdceeqez4gge7zci8oic.jpg',
        'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109607/Images/Sumizan%20Images/Apps/sbikvothltnacoggih3t.jpg',
        'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109606/Images/Sumizan%20Images/Apps/axf8rfqzcclyv4liswgq.jpg',
        'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109598/Images/Sumizan%20Images/Apps/gb2fbyxbj3vwdkbp5uvc.jpg'
        ],
        width: '35vw',
      },
      {
        tabTitle: 'Backend',
        categories:[
        'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109638/Images/Sumizan%20Images/Backend/tetqdxgnayxw0w8oqv6x.jpg', 
        'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109637/Images/Sumizan%20Images/Backend/rotvvrjs7apchbkm3ktq.jpg', 
        'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109633/Images/Sumizan%20Images/Backend/tbkilgmynqemco4ugurh.jpg',
        'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109630/Images/Sumizan%20Images/Backend/qrzvkulvbrruuiynywhw.jpg'
        ],
        width: '35vw',
      },
      {
        tabTitle: 'Cloud',
        categories:[
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109660/Images/Sumizan%20Images/Cloud/tvbrbusqqiixizjrfluq.jpg', 
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109647/Images/Sumizan%20Images/Cloud/nvzcxjeli0791akbdf9b.jpg', 
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109638/Images/Sumizan%20Images/Cloud/o7pldou18s5inekr1red.jpg',
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109638/Images/Sumizan%20Images/Cloud/l36l84hrptqqdeuvzxhe.jpg'
        ],
        width: '35vw',
      },
      {
        tabTitle: 'Artificial Intelligence',
        categories:[
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109624/Images/Sumizan%20Images/Ai/vigbesilgcigt0ctx8bv.jpg', 
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109595/Images/Sumizan%20Images/Ai/vclz7toasszmk7zyk92z.jpg', 
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109592/Images/Sumizan%20Images/Ai/ke9gza0tw4bihvbg7hep.jpg',
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109589/Images/Sumizan%20Images/Ai/ntou5oc6cfhojmnhf99c.jpg', 
        ],
        width: '35vw',
      },
      {
        tabTitle: 'MVP Development',
        categories:[
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109696/Images/Sumizan%20Images/MVP/wztmjhmypqk8zuiwcn3d.jpg', 
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109692/Images/Sumizan%20Images/MVP/vfafqvpr0xzafux7hcd8.jpg', 
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109690/Images/Sumizan%20Images/MVP/hkrjkhfl1tlmpmedjuii.jpg',
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109689/Images/Sumizan%20Images/MVP/hfrmqtdki5gdj2hrgt9u.jpg'
        ],
        width: '35vw',
      },
      {
        tabTitle: 'Game Development',
        categories:[
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109690/Images/Sumizan%20Images/Game%20Development/erbnox84oeieic26mrvt.jpg', 
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109681/Images/Sumizan%20Images/Game%20Development/dfuabxp83u2fqrnxbx1v.jpg', 
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109667/Images/Sumizan%20Images/Game%20Development/zy4mmblq2ivjq6mebd7k.jpg',
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109656/Images/Sumizan%20Images/Game%20Development/nb2wt1jnti36f8w60bih.jpg'
        ],
        width: '35vw',
      },
      {
        tabTitle: 'Staffing Solutions',
        categories:[
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109705/Images/Sumizan%20Images/Staffing%20Solutions/p6ctqqnokht4lnggujz1.jpg', 
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109703/Images/Sumizan%20Images/Staffing%20Solutions/zo8distboagtli20n360.jpg', 
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109702/Images/Sumizan%20Images/Staffing%20Solutions/r9pgdlq24gqun7llaz3a.jpg',
          'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109701/Images/Sumizan%20Images/Staffing%20Solutions/il72cfd5jkjpdufoxuu6.jpg'
        ],
        width: '35vw',
      }
      ];
  return (
    <React.Fragment>
         <div className="section1" data-aos="fade-right">
                <div className="sectionData">

                    <h1 style={{fontSize: '5.8rem', width: '35vw'}}>
                        Portfolio
                    </h1>
                    <br/>
                    <span className='d-flex mt-3 mb-1 first_span'>Our work performs as it sees</span>
                    <br/>
                    <span className='sec_span'>
                      We create beautiful, interesting, and responsive web and mobile applications
                    </span>
                    <div className="btnGroup">
                      <Link to='/contact'>
                        <button className="btn1">Contact Us</button>
                      </Link>
                    </div>
                </div>
                <div className="sectionGraphics">
                  <SkewImg image={'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109756/Images/a1kgcazt5ztzhgjm3e8i.png'}/>
                </div>
            </div>

            <div className="servicesTabs" data-aos="fade-left">
                <Tab tabs={{tabsData, constIdea}} />      
            </div>
    </React.Fragment>
  )
}

export default Portfolio

const constIdea = () => {
  return (
    <React.Fragment>
        <div className="section1 porfoIdeasSection" data-aos="fade-right">
            <div className="sectionData">
                <span style={{fontSize: '4rem', fontWeight: 'bold'}} className='mt-3 mb-1'>
                    We <span className='red'>Construct</span> Ideas
                </span>
                <div className="btnGroup">
                  <Link to='/contact'>
                    <button className="btn1" style={{width: 'auto', padding: '1rem 2rem'}}>Let’s Talk About Your Project</button>
                  </Link>
                </div>
            </div>

            <div>
              <LazyLoad>
                <img src={'https://res.cloudinary.com/dcbjyvxgh/image/upload/v1737109560/Images/htxpu5joswmc02b4zloq.png'} className='porfolio_bulbs_img' style={{width: '40rem', marginRight:'10rem'}}/>
              </LazyLoad>
            </div>
        </div>
    </React.Fragment>
  )
}